/**
 * ticketCierreFormat.ts — Formato de montos para ticket de cierre (web, térmica, PDF).
 */

export function formatTicketMoney(n: number): string {
  return `$${Math.round(n).toLocaleString("es-CO")}`;
}
